import React, { Fragment, Component } from "react";
// import { connect } from "react-redux";
// import { setPostLeaders } from "../../actions";
import { Segment, Comment, Icon } from "semantic-ui-react";
import MessagesHeader from "./MessagesHeader";
import MessageForm from "./MessageForm";
import Message from "./Message";
import {MyStore} from "../../../../services/Store";


import firebase from "firebase/app";
import "firebase/functions";



class Chats extends Component {
    constructor(props) {
        super(props)
    this.state = {
        // isDM: this.props.isDM,
        isDm: false,
        // currentGroup: this.props.currentGroup,
        currentUser: this.props.currentUser,
        currentGroup: '',
        // currentUser: MyStore.auth().currentUser,
        groupsRef: MyStore.database().ref().child("groups"),
        dmRef: MyStore.database().ref().child("directMessages"),
        messages: [],
        searchInput: "",
        searching: false,
        searchResults: [],
        loading: true
    };
}


     showFolderIcon = (currentGroup, isDM) => {
        return( currentGroup ? 
        <div><Icon name='folder open outline' /> {currentGroup.title}</div>
        :  "Loading..."
        );
      }
    


    getCurrentGroupName = (currentGroup, isDM) => {
   
        return (currentGroup
            ? `${isDM ? "@" : ''}     ${currentGroup.title}`
            : "Loading...")
    };

    getCurrentGroupSubheader = (currentGroup, isDM) => {
        if (isDM) {
            return "Direct Message";
        } else {
            if (currentGroup && currentGroup.members) {
                const numMembers = Object.keys(currentGroup.members).length;

                return numMembers === 1 ? "1 Member" : `${numMembers} Members`;
            } else {
                return "0 Members";
            }
        }
    };

    handleSearchChange = e => {
        
        this.setState(
            {
                searchInput: e.target.value,
                searching: true
            },
            () => {
                this.searchMessages();
            }
        );
    };

    searchMessages = () => {
        const { searchInput } = this.state;
        const messages = [...this.state.messages];
        const regex = new RegExp(searchInput, "gi");

        const searchResults = messages.reduce((acc, message) => {
            if (
                message.text.match(regex) ||
                message.author.username.match(regex)
            ) {
                acc.push(message);
            }
            return acc;
        }, []);
        this.setState({ searchResults });
        setTimeout(() => this.setState({ searching: false }), 400);
    };



        displayMessages = messages =>
        // messages.length > 0 &&
        messages.map(m => (
            <React.Fragment>
                {/* {console.log(m)} */}
                <Message key={m.id} message={m} user={this.state.currentUser} />
            </React.Fragment>
            
        
        ));



 

    getMessagesRef = () => {
        const { isDM, groupsRef, dmRef } = this.state;
        // return groupsRef.child(currentGroup.id).child("messages");
        // console.log('-------- current gourp line 104 -------')
        // console.log(currentGroup)


 
    

            if(this.props.oid !== undefined && this.props.currentGroup !== undefined){
            // console.log(this.props.currentGroup.logsGroupId)
            let logsRef = groupsRef.child(this.props.oid).child("chats").child(this.props.currentGroup.logsGroupId);
            return logsRef;

        }
   
 
    };

    getPostLeaders = messages => {
        const { setPostLeaders } = this.props;

        // console.log(messages)
        let leaders = messages.reduce((acc = {}, message) => {
            if (message.author.username in acc) {
                acc[message.author.username].count += 1;
            } else {
                acc[message.author.username] = {
                    avatar: message.author.avatar,
                    username: message.author.username,
                    count: 1
                };
            }
            return acc;
        }, {});
        // console.log(leaders);
        // setPostLeaders(leaders);
    };

    addMessageListeners = () => {
        
        let loadedMessages = [];
        // console.log('---line 156 --- addMessageListeners')
        const messagesRef = this.getMessagesRef();
        messagesRef.on("child_added", snap => {
            loadedMessages.push(snap.val());
            // console.log(loadedMessages)
            this.setState({
                messages: loadedMessages,
                loading: false
            });
            this.getPostLeaders(loadedMessages);
        });
    };

    
    addMessageListeners2 = () => {
        
        // if(this.props.oid !== undefined && this.props.currentGroup !== undefined){
            // console.log(this.props.currentGroup.logsGroupId)
            // console.log(this.props.oid)
            let logsRef = this.state.groupsRef.child(this.props.oid).child("chats").child(this.props.currentGroup.logsGroupId);
            // let logsRef = this.state.groupsRef.child('-LwLujWwcsr6szQxZYer').child("chats").child('"ec7d8cf4-84e8-4ccb-988d-9b30523a945e"');
     
            // return logsRef;

        let loadedMessages = [];
        // console.log('---line 179 --- addMessageListeners')
        // const messagesRef = this.getMessagesRef();

        logsRef.once("value", snap => {
        // logsRef.once('value', function(snap) {
            if (snap.exists() === false){
                // console.log(snap.exists())
                this.setState({messages:[]})
                return
            }
            
      
         });

               
         
        logsRef.on("child_added", snap => {
            loadedMessages.push(snap.val());
            // console.log(snap.val())
            this.setState({
                messages: loadedMessages,
                loading: false
            });
            


            this.getPostLeaders(loadedMessages);
        })
        
        
        
    };

    


    removeMessageListeners = () => {
        const { groupsRef, dmRef } = this.state;
        groupsRef.off();
        dmRef.off();
    };

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    };

    /**
     * Lifecycle Methods
     */
    static getDerivedStateFromProps(nextProps) {
        /**
         * currentGroup and currentUser will be null upon first
         * render so we need to set them again when props change
         */
        return {
            currentGroup: nextProps.currentGroup,
            currentUser: nextProps.currentUser
        };
    }

    callbackUpdate(){

        MyStore.auth().onAuthStateChanged((currentUser) => {
            if (currentUser) {

                this.addMessageListeners2();
            }
        })

        return(
            <>
            </>
        )
    }

    componentDidMount() {
        const {   currentUser, messages } = this.state;

        // console.log('--------- currentGroup  line 185-----------')
        // console.log(currentGroup)

        // console.log(this.props)
        // console.log('--------- key ------')
        // console.log(this.props.pid)
        // const cg = MyStore.database().ref().child("groups").child("-LwLokoEOlo2jFZHUsDJ")
        // this.setState({currentGroup: cg})


        // let a_dmRef =  MyStore.database().ref().child("groups").child("-LwLokoEOlo2jFZHUsDJ")
        // console.log(this.props.pid)
        // console.log(this.state.groupsRef.child(this.props.cgId).child("chats").child('7e6096da-1062-42e1-8799-32dba9a3d7ba'))
        // console.log(a_dmRef)stat



        // console.log(this.state.currentGroup)
        // console.log(this.state.currentUser)
        // console.log(this.state.groupsRef)
        // console.log(this.state.dmRef)

  


        //Add listener for new messages once we have a group and user
        if (currentUser) {
            this.addMessageListeners();
        }

        // if(this.props.oid !== undefined && this.props.pid!== undefined){
        //     this.addMessageListeners();
        //     console.log('chats line 316 ')
        // }

        // MyStore.auth().onAuthStateChanged((currentUser) => {
        //     if (currentUser) {

        //         this.addMessageListeners();
        //     }
        // })



        // this.scrollToBottom();
    }



    componentDidUpdate(prevProps, prevState) {

        // console.log(prevState)
        // console.log(prevProps)

        if(prevProps !== this.props && prevState !== this.state){
            // console.log('prevProps line 384')
            // console.log (prevProps)
            // console.log(this.props)
            this.callbackUpdate()

          
            //     console.log(this.props.currentGroup.logsGroupId)
            //     const logsRef = this.state.groupsRef.child(this.props.oid).child("chats").child(this.props.currentGroup.logsGroupId);
   
            // let loadedMessages = [];
 
            // logsRef.on("child_added", snap => {
            //     loadedMessages.push(snap.val());
                
            //     console.log(loadedMessages)
            //     this.setState({
            //         messages: loadedMessages,
            //         loading: false
            //     });
            //     this.getPostLeaders(loadedMessages);
            // });


            // this.callbackUpdate()
        }

        // if(this.props.oid !== undefined && this.props.pid!== undefined){
        //     this.addMessageListeners();
        //     console.log('chats line 316 ')
        // }
        
        if (this.messagesEnd) {
            // this.scrollToBottom();
            
        }
        // if(this.props.oid !== undefined && this.props.pid!== undefined){
        //     this.addMessageListeners();
        //     console.log('chats line 316 ')
        // }

    }




    // componentWillUnMount() {
    //     this.removeMessageListeners();
    // }

    render() {
        const {
            isDM,
            currentGroup,
            currentUser,
            messages,
            searchInput,
            searchResults,
            searching
        } = this.state;

        return (
            <Fragment >

   
                <MessagesHeader
               
           
                    handleSearchChange={this.handleSearchChange}
                    searchInput={searchInput}
                    searching={searching}

                    
                    // currentGroupName={this.getCurrentGroupName(
                    //     currentGroup,
                    //     isDM
                    // )}

                    currentGroupName={this.showFolderIcon(
                        currentGroup,
                        isDM

                    )}


                    subheader={this.getCurrentGroupSubheader(
                        currentGroup,
                        isDM
                    )}
                    
                >
         

                </MessagesHeader>
            
                <Segment
                    style={{
                        background: "transparent",
                        border: "1px solid transparent",
                        padding: "0em 0em"
                    }}
                >

                    <Comment.Group 
                        style={{ maxWidth: "none" }}
                        className="messages"
                    >
                        {searchInput
                            ? this.displayMessages(searchResults)
                            : this.displayMessages(messages)}
                        <div ref={node => (this.messagesEnd = node)} />
                    </Comment.Group>
                </Segment>

                <MessageForm
                    oid={this.props.oid}
                    currentGroup={this.props.currentGroup}
                    currentUser={currentUser}
                    isDM={isDM}
                />
            </Fragment>
        );
    }
}


export default Chats;
// export default connect(
//     null,
//     { setPostLeaders }
// )(Messages);
